import * as yup from 'yup';
import { minZeroMsg, requiredMsg } from '../../utils/validationMessages';
import { transactionCurrencyIdField } from '../../../../../../../schemas/transactions/TransactionsCommon.schema';
import { transactionDateSchema } from '../../../../../../Finance2/Forms/transactionFieldSchemas';
import { pricePerShareField } from '../../../../../../../schemas/common-schema-defs';

export function warrantExerciseFields() {
  return {
    fundId: yup.number().nullable().required(requiredMsg('Fund')),
    transactionDate: transactionDateSchema(),
    pricePerShare: pricePerShareField()
      .nullable()
      .required('Converted PPS')
      .moreThan(-Number.MIN_VALUE, minZeroMsg('Converted PPS')),
    currencyid: transactionCurrencyIdField(),
    exercisedWarrantsNo: yup
      .number()
      .nullable()
      .required(requiredMsg('Number of Shares Converted'))
      .min(0, minZeroMsg('Number of Shares Converted')),
    warrantExercisePrice: yup.number(),
    security: yup
      .string()
      .optional()
      .nullable()
      .transform((_, val) => (val === val ? val : null)),
    notes: yup
      .string()
      .optional()
      .nullable()
      .transform((_, val) => (val === val ? val : null)),
  };
}

export function warrantExerciseFormSchema() {
  return yup.object().shape(warrantExerciseFields());
}
